import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

// view del login e della registrazione
import Login from "../views/Login.vue"; // chiede utente e password, gestisce registrazione e password dimenticata
import Registrati from "../views/Registrati.vue"; // videata per introdurre i dati della registrazione della struttura

// view del menù di amministrazione
import Amministrazione from "../views/Amministrazione.vue";
import ModificaDatiStruttura from "../views/ModificaDatiStruttura.vue";
import GestioneUtenti from "../views/GestioneUtenti.vue";
import ModificaUtente from "../views/ModificaUtente.vue";
import BackOffice from "../views/BackOffice.vue";

// view del menù partner
import MenuPartner from "../views/MenuPartner.vue";
import ModificaDatiPartner from "../views/ModificaDatiPartner.vue";
import GestioneStrutture from "../views/GestioneStrutture.vue";
import ModificaStruttura from "../views/ModificaStruttura.vue";

// view visualizzate all'interno della home page
import Home from "../views/Home.vue";
import Errore from "../views/Errore.vue"; // si ' verificato un errore bloccante
import CheckInNonAttivato from "../views/CheckInNonAttivato.vue"; // per la prenotazione richiesta il check-in non è ancora stato attivato
import CheckInAggiornato from "../views/CheckInAggiornato.vue"; // i dati inseriti dal cliente sono stati memorizzati in banca dati
import ResettaPassword from "../views/ResettaPassword.vue"; // videata con pulsante per resettare la password
import EmailResetInviata from "../views/EmailResetInviata.vue"; // videata che comunica che l'email è stata inviata
import ReintroduciPassword from "../views/ReintroduciPassword.vue"; // videata per reintrodurre la password dell'utente
import RegistrazioneInviata from "../views/RegistrazioneInviata.vue"; // videata che comunica che i dati della registrazione sono stati inviati
import CompletaRegistrazione from "../views/CompletaRegistrazione.vue"; // videata richiamata dal link nell'email di registrazione
import PiuInformazioniStruttura from "../views/PiuInformazioniStruttura.vue"; // videata con informazioni aggiuntive riservata alle strutture
import PiuInformazioniPartner from "../views/PiuInformazioniPartner.vue"; // videata con informazioni aggiuntive riservata ai partner
import InformativaSito from "../views/InformativaSito.vue"; // videata con informazioni sulla privacy generale del sito
import InformativaRegistrazionePartner from "../views/InformativaRegistrazionePartner.vue"; // videata con informazioni sulla privacy per la registrazione del partner
import InformativaRegistrazioneStruttura from "../views/InformativaRegistrazioneStruttura.vue"; // videata con informazioni sulla privacy per la registrazione della struttura
import InformativaRichiestaInformazioni from "../views/InformativaRichiestaInformazioni.vue"; // videata con informazioni sulla privacy del form di richiesta informazioni
import InformazioniLegali from "../views/InformazioniLegali.vue"; // videata con informazioni legali

// view del checkin
import CheckIn from "../views/CheckIn.vue"; // controlla i dati del link e poi chiama il componente DatiCheckIn.vue
import LinkNonValido from "../views/LinkNonValido.vue"; // se è cercato di entrare nel check-in online con un url errato

Vue.use(VueRouter);

// Creare una route per ogni tipo di parametri di input.
// Per esempio /reservation_code?hid=xxxxx oppure /booking.com?reservationcode=cripted_value
const routes = [
  {
    path: "/",
    name: "Root",
    component: Login
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/registrati",
    name: "Registrati",
    component: Registrati
  },
  {
    path: "/amministrazione",
    name: "Amministrazione",
    component: Amministrazione,
    meta: {
      requiresAuth: true,
      is_admin: false
    },
    children: [
      {
        path: '/amministrazione/modificadatistruttura',
        name: "ModificaDatiStruttura",
        component: ModificaDatiStruttura,
        meta: {
          requiresAuth: true,
          is_admin: true
        },
      },
      {
        path: '/amministrazione/gestioneutenti',
        name: "GestioneUtenti",
        component: GestioneUtenti,
        meta: {
          requiresAuth: true,
          is_admin: true
        },
      },
      {
        path: '/amministrazione/modificautente',
        name: "ModificaUtente",
        component: ModificaUtente,
        meta: {
          requiresAuth: true,
          is_admin: true
        },
        props: true
      },
      {
        path: '/amministrazione/backoffice',
        name: "BackOffice",
        component: BackOffice,
        meta: {
          requiresAuth: true,
          is_admin: false
        },
      },
    ]
  },
  {
    path: "/menupartner",
    name: "MenuPartner",
    component: MenuPartner,
    props: true,
    meta: {
      requiresAuth: true,
      is_partner: true
    },
    children: [
      {
        path: '/menupartner/modificadatipartner',
        name: "ModificaDatiPartner",
        component: ModificaDatiPartner,
        props: true,
        meta: {
          requiresAuth: true,
          is_partner: true
        },
      },
      {
        path: '/menupartner/gestionestrutture',
        name: "GestioneStrutture",
        component: GestioneStrutture,
        props: true,
        meta: {
          requiresAuth: true,
          is_partner: true
        },
      },
      {
        path: '/menupartner/modificastruttura',
        name: "ModificaStruttura",
        component: ModificaStruttura,
        props: true,
        meta: {
          requiresAuth: true,
          is_partner: true
        },
      },

    ]
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false,
      is_admin: false
    },
    children: [
      {
        path: "/home/errore",
        name: "Errore",
        component: Errore,
        props: true
      },
      {
        path: "/home/checkinnonattivato",
        name: "CheckInNonAttivato",
        component: CheckInNonAttivato,
        props: true
      },
      {
        path: "/home/resettapassword",
        name: "ResettaPassword",
        component: ResettaPassword,
        props: true
      },
      {
        path: "/home/emailresetinviata",
        name: "EmailResetInviata",
        component: EmailResetInviata,
        props: true
      },
      {
        path: "/home/reintroducipassword",
        name: "ReintroduciPassword",
        component: ReintroduciPassword,
        props: true
      },
      {
        path: "/home/registrazioneinviata",
        name: "RegistrazioneInviata",
        component: RegistrazioneInviata,
        props: true
      },
      {
        path: "/home/completaregistrazione",
        name: "CompletaRegistrazione",
        component: CompletaRegistrazione,
        props: true
      },
      {
        path: "/home/linknonvalido",
        name: "LinkNonValido",
        component: LinkNonValido,
      },
      {
        path: "/home/checkinaggiornato",
        name: "CheckInAggiornato",
        component: CheckInAggiornato,
        props: true
      },
      {
        path: "/home/piuinformazionistruttura",
        name: "PiuInformazioniStruttura",
        component: PiuInformazioniStruttura,
        props: true
      },
      {
        path: "/home/piuinformazionipartner",
        name: "PiuInformazioniPartner",
        component: PiuInformazioniPartner,
        props: true
      },
      {
        path: "/home/informativasito",
        name: "InformativaSito",
        component: InformativaSito,
        props: true
      },
      {
        path: "/home/informativaregistrazionepartner",
        name: "InformativaRegistrazionePartner",
        component: InformativaRegistrazionePartner,
        props: true
      },
      {
        path: "/home/informativaregistrazionestruttura",
        name: "InformativaRegistrazioneStruttura",
        component: InformativaRegistrazioneStruttura,
        props: true
      },
      {
        path: "/home/informativarichiestainformazioni",
        name: "InformativaRichiestaInformazioni",
        component: InformativaRichiestaInformazioni,
        props: true
      },
      {
        path: "/home/informazionilegali",
        name: "InformazioniLegali",
        component: InformazioniLegali,
        props: true
      },
    ]
  },
  {
    path: "/backoffice/:origine",
    name: "BackOfficeOrigine",
    component: CheckIn,
    props: true
  },
  {
    path: "/online/:origine",
    name: "OnlineOrigine",
    component: CheckIn,
    props: true
  },
  {
    path: "*",
    name: "default",
    redirect: "/home/linknonvalido",
    component: LinkNonValido
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  }
})

router.beforeEach((to, from, next) => {
  try {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const is_admin = to.matched.some(record => record.meta.is_admin);
    const is_partner = to.matched.some(record => record.meta.is_partner);

    if ((requiresAuth && !store.state.UtenteAutenticato) ||
      (is_admin && !store.state.UtenteAmministratore) ||
      (is_partner && !store.state.UtentePartner)) {
      store.commit("SettaPathToLoadAfterLogin", JSON.stringify(to));
      next("/login");
    }
    else {
      next();
    }
  }
  catch (error) {
    console.log(error)
  }
});

export default router
